import { render, staticRenderFns } from "./ai-chain-of-thought-dialog.vue?vue&type=template&id=512d885f&scoped=true&"
import script from "./ai-chain-of-thought-dialog.vue?vue&type=script&lang=js&"
export * from "./ai-chain-of-thought-dialog.vue?vue&type=script&lang=js&"
import style0 from "./ai-chain-of-thought-dialog.vue?vue&type=style&index=0&id=512d885f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d885f",
  null
  
)

export default component.exports